export default __webpack_public_path__ + "static/media/mits.7d0f39d6.webp";